module.exports = __webpack_public_path__ + "static/media/Immobilier-Valorisation-Vaud.d0458e39.jpg";